import {
  Directive, Input, ElementRef, Renderer2, Inject, NgModule, AfterViewInit,
  ReflectiveInjector
} from "@angular/core";
import {Aot2JitSharingService} from "../../../services/aot2jitsharing.service";

declare var SocialShareKit: any;

class ShareButtonsDirectiveClass {

  public src: string;
  public text: string;
  public shareImage: string;
  public facebookTitle: string;
  public facebookText: string;
  public twitterUrl: string;
  public twitterText: string;
  public pinterestImage: string;
  public element: any;

  protected isBrowser: boolean;

  constructor() {
    let injector = ReflectiveInjector.resolveAndCreate([Aot2JitSharingService]);
    let aot2JitSharingService = injector.get(Aot2JitSharingService);
    this.isBrowser = aot2JitSharingService.getProvider('isBrowser');

  }

  public onLoad(event) {
    if(this.isBrowser) {
      this.renderShareButtons(event.target);
    }
  }



  protected renderShareButtons(element: any) {

    var contentHtml = '<div class="socialButtons ssk-group ssk-left-image ssk-gray" data-url="' + this.getOgUrl() + '" data-text="' + this.text + '" ';

    if (this.pinterestImage != null && this.pinterestImage.trim().length > 0) {
      contentHtml += ' data-image="' + this.getUrlWithProtocol(this.pinterestImage.trim()) + '"';
    }
    else if (!!this.src && this.src.match(/\.(jpg|jpeg|png|gif)$/)) {
      contentHtml += ' data-image="' + this.getUrlWithProtocol(this.src) + '"';
    }
    contentHtml += '>';

    //twitter
    contentHtml += '<a href="" class="ssk ssk-twitter" ';
    if (this.twitterUrl != null && this.twitterUrl.trim().length > 0) {
      contentHtml += 'data-url="' + this.twitterUrl.trim() + '" ';
    }
    if (this.twitterText != null && this.twitterText.trim().length > 0) {
      contentHtml += 'data-text="' + this.twitterText.trim() + '" ';
    }
    contentHtml += '></a>';

    //facebook
    contentHtml += '<a href="" class="ssk ssk-facebook" ';
    if (this.shareImage != null && this.shareImage.trim().length > 0) {
      contentHtml += 'data-image="' + this.getUrlWithProtocol(this.shareImage.trim()) + '" ';
    }
    if (this.facebookTitle != null && this.facebookTitle.trim().length > 0) {
      contentHtml += 'data-title="' + this.facebookTitle.trim() + '" ';
    }
    if (this.facebookText != null && this.facebookText.trim().length > 0) {
      contentHtml += 'data-text="' + this.facebookText.trim() + '" ';
    }
    contentHtml += '></a>';

    $(element).before('<div class="resourceContainer"></div>');
    var div = $(element).prev();

    $(element).remove();
    $(div).append(contentHtml);
    $(div).append(element);

    $(div).append('<div class="share-mobile"><a href class="show-mobile-share-buttons"><i class="fa fa-2x fa-share-alt-square"></i></a></div>');

    $('a.show-mobile-share-buttons').on('click', function(event){
      event.preventDefault();
      $('.ssk-mobile').css('display', 'block');
      $('.share-mobile').css('display', 'none');
    });

    contentHtml = contentHtml.replace('ssk-left-image', 'ssk-mobile');
    contentHtml = contentHtml.replace('ssk-gray', '');
    contentHtml = contentHtml.replace('socialButtons', '');

    $(div).append(contentHtml);

    SocialShareKit.init({
      url : this.getOgUrl()
    });

    // Only in desktop view (@screen-md-min = 992px)
    if($(window).width() > 992) {

      // Hack to show share-buttons on images with width=120%
      $('div.socialButtons').each(function(){
        if($(this).parent().find('img').hasClass('full-img')) {
          $(this).addClass('ssk-left-image-full-img');
        }
      });

      var isPointerIntoExpandedArea = function(element, x, y) {
        var distance = 75,
          left = 0,
          right = $(window).width(),
          top = element.offset().top - distance,
          bottom = top + element.height() + distance;

        return (x > left && x < right && y > top && y < bottom);
      };

      var displayAndFixSocialButtons = function(x, y) {

        var socialButtons = $(div).find('div.socialButtons:first');
        var currentImage = $(div).find('[share-buttons]:first');
        var displaySB = socialButtons.css('display');

        if(currentImage.is(':hover')){
          if(!displaySB || displaySB == 'none') {
            socialButtons.css('display', 'inline');
            $('div.socialButtons').each(function(){
              if(!$(this).is(socialButtons)) {
                $(this).css('display', 'none');
              }
            });
          }

          /*
          if(!$.isScrollToFixed(socialButtons)) {
            socialButtons.scrollToFixed({
              marginTop: 10,
              limit: currentImage.offset().top + currentImage.outerHeight(true) - socialButtons.outerHeight(true),
              zIndex: 999,
              removeOffsets: true,
              spacerClass: 'display-none'
            });
            $('div.socialButtons').each(function(){
              if(!$(this).is(socialButtons)) {
                $(this).trigger('detach.ScrollToFixed');
              }
            });
          }
          */

        }

        if(!!displaySB && displaySB != 'none' && !isPointerIntoExpandedArea(currentImage, x, y)) {
          socialButtons.css('display', 'none');
          socialButtons.trigger('detach.ScrollToFixed');
        }

      };


      $('body').mousemove(function(event) {
        displayAndFixSocialButtons(event.pageX, event.pageY);
      });
    }
/*

    $(div).find('a.ssk-share-link:first').on('click', function(){
      if($('#republish_link').length > 0) {
        $anchorScroll.yOffset = 25;
        $('#republish_link').css('display', '');
        $location.hash('republish_link');
        $anchorScroll();
      }
    });

*/

  }

  protected  getOgUrl() {
    var links = document.getElementsByTagName('link');

    for (var i=0; i<links.length; i++) {
      if (links[i].getAttribute("rel") == "og:url") {
        return links[i].getAttribute("href");
      }
    }

    return "";
  }

  protected getUrlWithProtocol(imageUrl) {
    return (!!imageUrl && imageUrl.indexOf('http') == -1) ? ('http:' + imageUrl) : imageUrl;
  }

}

let ShareButtonsDirective = Directive({
  selector: '[share-buttons]',
  inputs: [
    'src',
    'text',
    'shareImage',
    'facebookTitle',
    'facebookText',
    'twitterUrl',
    'twitterText',
    'pinterestImage'
  ],
  host : {
    '(load)' : 'onLoad($event)'
  }
})(ShareButtonsDirectiveClass);

export {ShareButtonsDirective, ShareButtonsDirectiveClass};




// WEBPACK FOOTER //
// ./src/app/shared/directives/article/directives/share-buttons.directive.ts